angular.module('autoremind.templates')
    .controller('autoremind.users.templatesController', ['$rootScope', '$scope', '$location', 'dialogs', 'userProfile', 'accountService', 'templateService', 'eventSharingService',
    function ($rootScope, $scope, $location, dialogs, userProfile, accountService, templateService, eventSharingService) {
        $scope.templateService = templateService;
        // Initialize
        userProfile.initalizeViewModel();
        if (!angular.isDefined(userProfile.viewModel.views.admin)) {
            // This is the first time opening the admin view, so initialize
            userProfile.viewModel.views.admin = {};
        }
        if (!angular.isDefined(userProfile.viewModel.views.admin.templates)) {
            // This is the first time opening the admin.templates view, so initialize
            userProfile.viewModel.views.admin.templates = {};
        }
        //$scope.viewModel = {};
        $scope.viewModel = userProfile.viewModel.views.admin.templates;
        //$scope.viewModel = {};
        $scope.viewModel.loadingIndicator = { 'state': false, 'refCount': 0 };
        $scope.viewModel.userId = $location.search()['userid'] || accountService.selectedUserId;
        $scope.templateService.model.currentUser = $scope.viewModel.userId;
        $scope.viewModel.selectedUserInfo = {};
        $scope.isAutoremind3Page = function () {
            var url = $location.absUrl();
            return url.indexOf('autoremind2') === -1;
        };
        if (angular.isDefined($scope.viewModel.userId) && $scope.viewModel.userId !== '') {
            accountService.getUser($scope.viewModel.userId, undefined, $scope.viewModel.loadingIndicator)
                .then(function (user) {
                if (user.notInAccounts && $scope.isAutoremind3Page()) {
                    dialogs.notify('Caution', 'Selected user (' + user.userName + ') only exist in legacy Autoremind. Either the user is no longer used or it is a partner.');
                    // This will ensure user tab is hidden if user not valid
                    $scope.userId = undefined;
                    $scope.viewModel.userId = undefined;
                    $scope.viewModel.selectedUserInfo = undefined;
                    $scope.viewModel.selectedUser = undefined;
                    accountService.selectedUserId = undefined;
                    $scope.templateService.model.currentUser = undefined;
                    if ($location.$$search.userid) {
                        // Delete userid from url
                        delete $location.$$search.userid;
                        $location.$$compose();
                    }
                }
                else {
                    $scope.viewModel.selectedUserInfo = user;
                    $scope.viewModel.selectedUser = user;
                    accountService.setSelectedUser(user);
                    $scope.templateService.model.currentUser = $scope.viewModel.userId;
                }
            });
        }
        $scope.searchUsersList = function (pattern) {
            $scope.viewModel.selectedUser = null; // None selected, so user details should be hidden
            $scope.viewModel.detailsVisible = false;
            return accountService.searchUser(pattern, $scope.viewModel.loadingIndicator)
                .then(function (users) {
                return $scope.viewModel.usersList = users;
            });
        };
        $scope.getSelectedUserData = function () {
            if ($scope.viewModel.selectedUser === null) {
                return;
            }
            $location.search('userid', $scope.viewModel.selectedUser.userId);
        };
    }]);
//# sourceMappingURL=templates.controller.js.map